import { useQuery } from '@tanstack/react-query';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '@/config/firebase';

// ================================================
// HOOK PARA OBTER ID DO COLABORADOR POR EMAIL
// Usa coleção public para fazer lookup por email
// ================================================

/**
 * Hook para obter o ID do colaborador através do email
 * Utiliza a coleção collaborators_public que é otimizada para consultas
 */
export function useCollaboratorIdByEmailQuery(email?: string) {
    return useQuery<string | null>({
        queryKey: ['collaborator_id_by_email', email],
        queryFn: async () => {
            if (!email) return null;

            console.log(`[id-by-email] Looking up collaborator ID for email: ${email}`);

            const q = query(
                collection(db, 'collaborators_public'),
                where("email", "==", email)
            );

            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                console.log(`[id-by-email] No collaborator found for email: ${email}`);
                return null;
            }

            const collaboratorId = querySnapshot.docs[0].id;
            console.log(`[id-by-email] Found collaborator ID: ${collaboratorId} for email: ${email}`);

            return collaboratorId;
        },
        enabled: !!email,
        staleTime: 10 * 60 * 1000, // 10 minutos - email-to-ID mapping raramente muda
    });
} 